// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import ElementUI from 'element-ui'
import './assets/css/base.scss'
import './assets/css/elementUpdata.scss'
import 'element-ui/lib/theme-chalk/index.css'
import api from './api/api.js'
// import $ from "jquery"
import axios from 'axios'
import qs from 'qs'
import "babel-polyfill"
Vue.use(ElementUI)

import router from './router'
Vue.config.productionTip = false
axios.defaults.withCredentials = true;
axios.defaults.headers.common['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8'
let token = window.localStorage.getItem('wd_authorization_token');
console.log(token, 'mainToken')
axios.defaults.headers.common["Authorization"] = token;
// axios.defaults.headers['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';
Vue.prototype.$http = axios;
Vue.prototype.$api = api;
axios.interceptors.request.use((config) => {
  if (config.data && config.method === 'post' && config.data.constructor !== FormData) {
    //判断config.data.constructor不是formdata，则不qs格式化data
    config.data = qs.stringify(config.data, { arrayFormat: 'repeat' });

  }
  return config;
}, (error) => {
  return Promise.reject(error);
});

axios.interceptors.response.use(response => {
  // let matchStr = JSON.stringify(response.data) //匹配未登录标识
  if (response.data.code == "401") {
    Vue.prototype.$message({ type: "error", message: response.data.msg });
    router.push({ path: '/login' })
  } else {
    return response
  }
}, (error) => {
  // router.push({path: '/login'})
  Vue.prototype.$message({ type: "error", message: "网络错误" });
  return Promise.reject(error)
})
// console.log(448,process.env.NODE_ENV);testing
if (location.href.indexOf("localhost") > -1) {
  axios.defaults.baseURL = 'http://api.wanda.mcmore.cn'
  Vue.prototype.$baseUrl = 'http://api.wanda.mcmore.cn'
  localStorage.setItem('baseUrl', 'http://api.wanda.mcmore.cn')
} else {

  // 测试域名
  // http://api.wanda.mcmore.cn

  // console.log(33, process.env.NODE_ENV);
  // axios.defaults.baseURL = `${window.location.protocol}//${window.location.host}`
  // Vue.prototype.$baseUrl = `${window.location.protocol}//${window.location.host}`
  // localStorage.setItem('baseUrl', `${window.location.protocol}//${window.location.host}`)
  if (process.env.NODE_ENV === 'testing') {
    axios.defaults.baseURL = `http://api.wanda.mcmore.cn`
    Vue.prototype.$baseUrl = `http://api.wanda.mcmore.cn`
    localStorage.setItem('baseUrl', `http://api.wanda.mcmore.cn`)
  } else if (process.env.NODE_ENV === 'production') {
    axios.defaults.baseURL = `https://wuyou.bototyre.com`
    Vue.prototype.$baseUrl = `https://wuyou.bototyre.com`
    localStorage.setItem('baseUrl', `https://wuyou.bototyre.com`)
  }

}
new Vue({
  el: '#app',
  router,
  components: {
    App
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js